import { render, staticRenderFns } from "./AddTopic.vue?vue&type=template&id=1326ff46&scoped=true"
import script from "./AddTopic.vue?vue&type=script&lang=js"
export * from "./AddTopic.vue?vue&type=script&lang=js"
import style0 from "./AddTopic.vue?vue&type=style&index=0&id=1326ff46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326ff46",
  null
  
)

export default component.exports